export const whyChooseUsConfig = {
  maxIconRowCount: 2,
  minIconRowCount: 1,
};
export const whyChooseUsBgShapeConfig = {
  maxIconRowCount: 10,
  iconSizeTabletToDesktop: 48,
  iconSizeMobile: 40,
  iconSize: 46,
  iconSizeWithMaxIconRowCount: 40,
  restrictIconSizeRowCount: 8,
};
export const whyChooseUsColumnConfig = {
  iconSize: 46,
  iconSizeTabletToDesktop: 48,
  iconSizeMobile: 40,
  iconSizeAboveDesktop: 80,
};

export const whyChooseUsBgImageConfig = {
  tabletDesktopFontSize: 28,
  mobileFontSize: 16,
  defaultFontSize: 46,
};
